import { Snackbar } from 'components/Snackbar';
import useDebounce from 'hooks/useDebounce';
import { useLoader } from 'hooks/utilHooks';
import { createContext, ReactNode, useEffect, useState } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { IEvaluationFilter } from 'types/Evaluation';
import { IHistoricFilter } from 'types/Historic';

import { AlertColor } from '@mui/material';

export interface IHistoricContext {
  loading: boolean;
  // handlePreviousPage: () => void;
  // handleNextPage: () => void;
  handleRefresh: () => void;
  setSnackbar: Function;
  docs: IHistoric[];
}

interface ISnackbar {
  message: string | null;
  variant?: AlertColor | undefined;
}

type IHistoricList = {
  docs: IHistoric[];
};

type IHistoric = {
  createAt: string;
  tutorName: string;
  petName: string;
  consult: {
    consultType: string;
  };
};

export enum ConsultTypeEnum {
  'teleorientation' = 'Teleorientação',
  'teleconsultation' = 'Teleconsulta',
}

export const HistoricContext = createContext<IHistoricContext>(
  {} as IHistoricContext
);

type Props = {
  children: ReactNode;
};

export const HistoricProvider = ({ children }: Props) => {
  const [historic, setHistoric] = useState<IHistoricList>({
    docs: [],
  } as unknown as IHistoricList);

  const filterForm = useForm<IHistoricFilter>({
    defaultValues: { startDate: null, endDate: null, tutorName: '' },
  });

  const [startDate, endDate, tutorName] = useWatch({
    control: filterForm.control,
    name: ['startDate', 'endDate', 'tutorName'],
  });

  const debouncedValue = useDebounce<string | undefined>(tutorName, 500);

  const { loading, showLoader, hideLoader } = useLoader(false);

  const [snackbar, setSnackbar] = useState<ISnackbar>({
    message: '',
    variant: 'info',
  });

  const getHistoric = async ({ page, limit }: IEvaluationFilter) => {
    try {
      showLoader();

      const historicList = {
        docs: [
          {
            createAt: '02/06/2022',
            tutorName: 'Juan Barbosa',
            petName: 'Bolinha',
            consult: {
              consultType: ConsultTypeEnum['teleorientation'],
            },
          },
          {
            createAt: '14/02/2022',
            tutorName: 'Ana Carolina Peixoto',
            petName: 'Joaninha',
            consult: {
              consultType: ConsultTypeEnum['teleconsultation'],
            },
          },
          {
            createAt: '28/01/2022',
            tutorName: 'Augusto Nunes',
            petName: 'Bolota',
            consult: {
              consultType: ConsultTypeEnum['teleorientation'],
            },
          },
        ],
      };

      setHistoric(historicList);

      // await historicervice.findAllhistoric({
      //   page,
      //   limit,
      //   vetName,
      //   startDate,
      //   endDate,
      // }).then(setHistoric);
    } catch (error) {
      const { message } = error as Error;

      setSnackbar({
        message,
        variant: 'error',
      });
    } finally {
      hideLoader();
    }
  };

  // const handlePreviousPage = () => {
  //   getHistoric({
  //     page: historic.prevPage,
  //   });
  // };

  // const handleNextPage = () => {
  //   getHistoric({
  //     page: historic.nextPage,
  //   });
  // };

  const handleRefresh = () => {
    getHistoric({});
  };

  useEffect(() => {
    getHistoric({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedValue, startDate, endDate]);

  return (
    <HistoricContext.Provider
      value={{
        loading,
        // handlePreviousPage,
        // handleNextPage,
        handleRefresh,
        setSnackbar,
        docs: historic.docs,
      }}
    >
      <FormProvider {...filterForm}>{children}</FormProvider>

      <Snackbar
        text={snackbar.message}
        snackbarOpen={Boolean(snackbar.message)}
        setSnackbarOpen={() => {
          setSnackbar({
            message: '',
          });
        }}
        severityType={snackbar.variant}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      />
    </HistoricContext.Provider>
  );
};
